import { render } from "./DepositRecords.vue?vue&type=template&id=06d984dc&scoped=true"
import script from "./DepositRecords.vue?vue&type=script&lang=js"
export * from "./DepositRecords.vue?vue&type=script&lang=js"

import "./DepositRecords.vue?vue&type=style&index=0&id=06d984dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06d984dc"]])

export default __exports__